module.exports = __webpack_public_path__ + "static/media/info-circle.777d7bd9.svg";